import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ae449f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message_main_wrap" }
const _hoisted_2 = { class: "message_avatar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "message_content" }
const _hoisted_5 = { class: "user_name" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = {
  key: 0,
  class: "nameplate offical"
}
const _hoisted_8 = {
  key: 1,
  class: "nameplate up"
}
const _hoisted_9 = { class: "time" }
const _hoisted_10 = {
  key: 0,
  class: "message_img_wrap"
}
const _hoisted_11 = {
  key: 1,
  class: "message_gift_wrap"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "mrew_cover" }
const _hoisted_14 = { class: "mrew_cover_text" }
const _hoisted_15 = { class: "mrew_cover_img" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "mrew_title" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 4,
  class: "hidden_txt"
}
const _hoisted_20 = {
  key: 5,
  class: "hidden_txt"
}
const _hoisted_21 = {
  key: 6,
  class: "message_ip"
}
const _hoisted_22 = {
  class: "comment_action_group_item",
  "data-key": 0
}
const _hoisted_23 = {
  key: 0,
  class: "comment_action_group_item",
  "data-key": 1
}
const _hoisted_24 = {
  key: 1,
  class: "comment_action_group_item",
  "data-key": 2
}
const _hoisted_25 = ["data-clipboard-text"]
const _hoisted_26 = {
  key: 3,
  class: "comment_action_group_item",
  "data-key": 4
}
const _hoisted_27 = {
  key: 4,
  class: "comment_action_group_item",
  "data-key": 5
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "comment_action_group_item",
  "data-key": 7
}, "删除", -1))

import { ref, computed, withDefaults } from 'vue';
import { message, Popconfirm } from 'ant-design-vue';
import { ElImage } from 'element-plus';
import { LuckMoney, Packet, Prize } from '@/assets';
import ClipboardJS from 'clipboard';
import { LightGMsg, LightImgContent, LightGiftContent, RedEnvelopeContent } from '@/pinia/types/livechat';
import { useConsoleStore } from '@/pinia/console';

interface Props {
  sourceData: LightGMsg;
  self: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LightGroupMsgItem',
  props: {
    sourceData: null,
    self: { type: Boolean, default: true }
  },
  emits: ['contextmenu:setEditUser', 'click:openPacket'],
  setup(__props: any, { emit }) {

const props = __props as { sourceData: LightGMsg, self: boolean };

const aPopconfirm = Popconfirm;
const elImage = ElImage;


const data = computed(() => props.sourceData);

const consoleStore = useConsoleStore();

const PacketUrl = computed(() => {
  if ((data.value.content as RedEnvelopeContent).type === 4 && (data.value.content as RedEnvelopeContent)?.contest_type === '2') {
    return Prize;
  } else if ((data.value.content as RedEnvelopeContent).type === 4) {
    return LuckMoney;
  } else {
    return Packet;
  }
});
const PacketClassName = computed(() => ((data.value.content as RedEnvelopeContent).type === 4 ? 'luck_style' : 'packet_style'));

const msgSetVisibel = ref(false);

const onClickMsgEdit = (event: Event) => {
  const keyIndex = parseInt((event.target as HTMLInputElement).dataset.key as string);
  if (keyIndex === 3) return;
  const formData = {
    key: keyIndex,
    data: data.value,
  };
  emit('contextmenu:setEditUser', formData);
};

const onDelMsg = (keyIndex: number) => {
  const formData = {
    key: keyIndex,
    data: data.value,
  };
  emit('contextmenu:setEditUser', formData);
};
const messageRef = ref();
const textCopy = ref();
const onCopyTxt = (event: Event, className: string) => {
  const ClipboardJSObj = new ClipboardJS(className);
  const formatStr = messageRef.value.innerHTML.replaceAll('<br><br>', '\n').replaceAll('<br>', '\n');
  textCopy.value = formatStr.replace(
    /<img [^>]*class="emoji" [^>]*alt=['"]([^'"]+)[^>]*>/gi,
    (match: any, capture: any) => capture
  );
  ClipboardJSObj.on('success', (e) => {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', () => {
    message.destroy();
    message.info('复制失败');
  });
};

// let oDiv = document.createElement('div');
// oDiv.innerHTML = data.value.content.toString();
// let text = oDiv.innerText;
// console.log(text);

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["message_main", { checked: msgSetVisibel.value }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(data).avatar_url,
          alt: ""
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(data).nickname), 1),
          (_unref(data).level)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "官方"))
            : _createCommentVNode("", true),
          (_unref(data).top_status)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "置顶"))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(data).created_at), 1)
        ]),
        (_unref(data).msg_type === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_unref(elImage), {
                src: (_unref(data).content as LightImgContent).url,
                "preview-src-list": [(_unref(data).content as LightImgContent).url],
                "hide-on-click-modal": "",
                teleported: ""
              }, null, 8, ["src", "preview-src-list"])
            ]))
          : (_unref(data).msg_type === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createTextVNode(" 送了" + _toDisplayString((_unref(data).content as LightGiftContent).title), 1),
                _createElementVNode("img", {
                  src: (_unref(data).content as LightGiftContent).image_url,
                  alt: ""
                }, null, 8, _hoisted_12),
                _createTextVNode(" x " + _toDisplayString((_unref(data).content as LightGiftContent).number), 1)
              ]))
            : (_unref(data).msg_type === 4)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["message_red_envelope_wrap", _unref(PacketClassName)]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click:openPacket', _unref(data).content)))
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString((_unref(data).content as RedEnvelopeContent).command), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("img", {
                        src: _unref(PacketUrl),
                        alt: ""
                      }, null, 8, _hoisted_16)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_17, _toDisplayString((_unref(data).content as RedEnvelopeContent).type_name), 1)
                ], 2))
              : (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  innerHTML: (_unref(data).content as string),
                  ref_key: "messageRef",
                  ref: messageRef,
                  class: "message_txt"
                }, null, 8, _hoisted_18)),
        (_unref(data).status === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_svg_icon, {
                class: "icon",
                "icon-class": "msg_hide"
              }),
              _createTextVNode("隐藏中...")
            ]))
          : _createCommentVNode("", true),
        (_unref(data).status === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_svg_icon, {
                class: "icon",
                "icon-class": "msg_hide"
              }),
              _createTextVNode("敏感词隐藏中...")
            ]))
          : _createCommentVNode("", true),
        (_unref(consoleStore).consoleInfo.addressStatus && _unref(data).address)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_svg_icon, { "icon-class": "console_address" }),
              _createTextVNode(_toDisplayString(_unref(data).address), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", {
      class: "comment_action_group",
      onClick: onClickMsgEdit
    }, [
      _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(data).status === 1 ? '隐藏' : '通过'), 1),
      ([1].includes(_unref(data).msg_type))
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, "弹幕"))
        : _createCommentVNode("", true),
      ([1, 3, 4].includes(_unref(data).msg_type))
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(data).top_status ? '取消置顶' : '置顶'), 1))
        : _createCommentVNode("", true),
      ([1].includes(_unref(data).msg_type))
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "comment_action_group_item copy_body",
            "data-key": 3,
            "data-clipboard-text": textCopy.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onCopyTxt($event, '.copy_body')))
          }, " 复制 ", 8, _hoisted_25))
        : _createCommentVNode("", true),
      (!props.self)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, "禁言"))
        : _createCommentVNode("", true),
      (!props.self)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, "拉黑"))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "comment_action_btn",
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(_unref(aPopconfirm), {
          title: "确定删除这条消息吗？",
          "ok-text": "确定",
          "cancel-text": "取消",
          onConfirm: _cache[2] || (_cache[2] = ($event: any) => (onDelMsg(7)))
        }, {
          default: _withCtx(() => [
            _hoisted_28
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})